import { absolutePath } from "./absolutePath";

interface ProfileFnProps {
  leadPublicId?: string;
  memberPublicId?: string;
  params?: Record<string, unknown>;
}

export const profile = {
  show: ({ memberPublicId, params = {} }: ProfileFnProps = {}) =>
    absolutePath(`profiles/${memberPublicId}`, params),
  update: ({ memberPublicId, params = {} }: ProfileFnProps = {}) =>
    absolutePath(`profiles/${memberPublicId}`, params),
  spaces: ({ memberPublicId, params = {} }: ProfileFnProps = {}) =>
    absolutePath(`profiles/${memberPublicId}/spaces`, params),
  posts: ({ memberPublicId, params = {} }: ProfileFnProps = {}) =>
    absolutePath(`profiles/${memberPublicId}/posts`, params),
  comments: ({ memberPublicId, params = {} }: ProfileFnProps = {}) =>
    absolutePath(`profiles/${memberPublicId}/comments`, params),
  signUpProfile: () => absolutePath(`signup/profile`),
  leadShow: ({ leadPublicId, params = {} }: ProfileFnProps = {}) =>
    absolutePath(`community_leads/${leadPublicId}`, params),
  leadUpdate: ({ leadPublicId, params = {} }: ProfileFnProps = {}) =>
    absolutePath(`community_leads/${leadPublicId}`, params),
};
